import { parse } from 'util/urlHelpers';
import { BOOKING_TRANSACTION_TYPE, QUERY_BY_ROLE, getQueryConfig } from '../config/tabs';
import generateOnlyFilter from './generateOnlyFilter';
import { getAllTransitionsForEveryProcess } from '../../../transactions/transaction';
import { INBOX_PAGE_SIZE } from '../config/constants';

const generateApiQueryParams = ({ params, search, additionalQueryParams }) => {
  const { tab } = params;
  const onlyFilter = generateOnlyFilter(params);

  const { page = 1, type = BOOKING_TRANSACTION_TYPE } = parse(search);

  const queryByRole = QUERY_BY_ROLE[type][tab] || {};
  const queryConfig = getQueryConfig();
  const processNames = queryConfig[type];

  return {
    only: onlyFilter,
    lastTransitions: getAllTransitionsForEveryProcess(),
    processNames,
    ...queryByRole,
    include: [
      'listing',
      'provider',
      'provider.profileImage',
      'customer',
      'customer.profileImage',
      'booking',
    ],
    'fields.transaction': [
      'processName',
      'lastTransition',
      'lastTransitionedAt',
      'transitions',
      'payinTotal',
      'payoutTotal',
      'lineItems',
      'protectedData',
      'createdAt',
    ],
    'fields.listing': [
      'title',
      'availabilityPlan',
      'publicData.listingType',
      'publicData.slug',
      'publicData.startTime',
      'publicData.endTime',
    ],
    'fields.user': ['profile.displayName', 'profile.abbreviatedName', 'deleted', 'banned'],
    'fields.image': ['variants.square-small', 'variants.square-small2x'],
    page,
    perPage: INBOX_PAGE_SIZE,
    ...additionalQueryParams,
  };
};

export default generateApiQueryParams;
